<template>
  <div v-if="showBanner" class="banner-container">
    <span class="text">
      <span class="font-weight-bold">{{ boldText }} </span> {{ text }}
    </span>
    <Button class="button-text" color="white" :text-color="experience" :to="localePath(buttonLink)">
      {{ buttonText }}
    </Button>
  </div>
</template>

<script>
import Button from 'UI/Button';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'Banner',
  components: {
    Button
  },
  computed: {
    ...mapGetters('search', ['isSearching']),
    ...mapState('search', ['searchResult']),
    ...mapGetters('experience', ['getExperience', 'getDefault']),
    showBanner() {
      return (
        !this.isSearching &&
        this.searchResult.length > this.$g('SEARCH_NOT_ENOUGH_RESULTS') &&
        (!this.$auth.loggedIn || this.$auth.user.idPlan === 1)
      );
    },
    text() {
      return this.$t(`main.searchResult.banner.${this.experience}Text`);
    },
    experience() {
      return this.getExperience || this.getDefault;
    },
    buttonText() {
      return this.$t(`main.searchResult.banner.${this.experience}ButtonText`);
    },
    boldText() {
      return this.$t(`main.searchResult.banner.${this.experience}BoldText`);
    },
    buttonLink() {
      return this.$urlBuilder('merch-plans', { keyword: 'listings' });
    }
  }
};
</script>

<style lang="scss" scoped>
.banner-container {
  width: 100%;
  background-color: var(--exp-color);
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 10px;
  margin: 15px 0;
  .text {
    margin: 0 10px;
    color: white;
  }
  .button-text {
    text-transform: uppercase;
  }
}
</style>
